import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "introGrid" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.introGrid.iconUrl,
        alt: "icon"
      }, null, 8, _hoisted_3),
      _createElementVNode("h4", null, _toDisplayString(_ctx.introGrid.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.introGrid.text), 1)
    ])
  ]))
}